<div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign="start" fxLayoutGap="15px">
	<div fxFlex="auto" fxFlex.gt-xs="40">
		<mat-card>
			<mat-card-header>{{'settlementDetailView.title' | translate}}</mat-card-header>
			<mat-card-content fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
				<div class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between" fxLayoutGap="5px">
					<div class="label">{{'settlementDetailView.driverLabel' | translate}}</div>
					<div>{{user?.driverId}} - {{settlementDetail?.driver}}</div>
				</div>
				<div class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between" fxLayoutGap="5px">
					<div class="label">{{'settlementDetailView.settlementGrossLabel' | translate}}</div>
					<div>{{settlementDetail?.settlementGross | currency:'USD':'symbol':'1.2-2'}}</div>
				</div>
				<div *ngFor="let deduction of settlementDetail?.deductions" class="bottom-border-row"
					 fxLayout="row wrap"
					 fxLayoutAlign="space-between"
					 fxLayoutGap="5px">
					<div class="label">{{deduction?.description}}</div>
					<div>{{deduction?.amount | currency:'USD':'symbol':'1.2-2'}}</div>
				</div>
				<div class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between" fxLayoutGap="5px">
					<div class="label">{{'settlementDetailView.settlementNetLabel' | translate}}</div>
					<div>{{settlementDetail?.settlementNet | currency:'USD':'symbol':'1.2-2'}}</div>
				</div>
				<div class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between" fxLayoutGap="5px">
					<div class="label">{{'settlementDetailView.generatedLabel' | translate}}</div>
					<div>{{settlementDetail?.generated?.formattedDate}} {{settlementDetail?.generated?.formattedTime}} {{settlementDetail?.generated?.timeZone}}</div>
				</div>
				<div *ngIf="settlementDetail?.timeFrameBegin || settlementDetail?.timeFrameEnd"
					 class="bottom-border-row"
					 fxLayout="row wrap" fxLayoutAlign="space-between"
					 fxLayoutGap="5px">
					<div class="label">{{'settlementDetailView.timeframeLabel' | translate}}</div>
					<div>{{settlementDetail?.timeFrameBegin?.formattedDate}}
						- {{settlementDetail?.timeFrameEnd?.formattedDate}}</div>
				</div>
				<div *ngIf="user?.showPrice" class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between"
					 fxLayoutGap="5px">
					<div class="label">{{'settlementDetailView.salesTotalLabel' | translate}}</div>
					<div>{{settlementDetail?.salesTotal | currency:'USD':'symbol':'1.2-2'}}</div>
				</div>
				<ng-container *ngIf="!user?.showTotalsOnly">
					<h3>Settlements</h3>
					<div fxLayout="column">
						<button (click)="setDateToDisplay(dt?.dueTimeTo?.formattedDate)"
								*ngFor="let dt of settlementDetail?.dateTotals; let i = index"
								[color]="dateToDisplay === dt?.dueTimeTo?.formattedDate ? 'primary' : null"
								class="space-between-button"
								mat-raised-button>
							<span>{{dt?.dueTimeTo?.formattedDate}}</span>
							<span>{{dt?.total | currency:'USD':'symbol':'1.2-2'}}</span>
						</button>
						<button (click)="setDateToDisplay(null)" [color]="dateToDisplay === null ? 'primary' : null"
								mat-raised-button
								type="button">{{'settlementDetailView.viewAllButton' | translate}}</button>
					</div>
				</ng-container>
			</mat-card-content>
		</mat-card>
	</div>
	<div *ngIf="!user?.showTotalsOnly" fxFlex fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
		<ng-container *ngFor="let d of settlementDetail?.settlementDetails">
			<mat-card *ngIf="d?.dueTimeTo?.formattedDate === dateToDisplay || dateToDisplay === null">
				<mat-card-header>
					{{'settlementDetailView.scheduleDateLabel' | translate}}: {{d?.dueTimeTo?.formattedDate}}
				</mat-card-header>
				<mat-card-content fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
					<div *ngIf="user?.showPieces" class="bottom-border-row" fxLayout="row wrap"
						 fxLayoutAlign="space-between" fxLayoutGap="5px">
						<div class="label">{{'settlementDetailView.piecesLabel' | translate}}</div>
						<div>{{d?.pieces}}</div>
					</div>
					<div *ngIf="user?.showWeight" class="bottom-border-row" fxLayout="row wrap"
						 fxLayoutAlign="space-between" fxLayoutGap="5px">
						<div class="label">{{'settlementDetailView.weightLabel' | translate}}</div>
						<div>{{d?.weight}}</div>
					</div>
					<div class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between" fxLayoutGap="5px">
						<div class="label">{{'settlementDetailView.idLabel' | translate}}</div>
						<div>{{d?.displayId}}</div>
					</div>
					<div *ngIf="user?.showGroup" class="bottom-border-row" fxLayout="row wrap"
						 fxLayoutAlign="space-between"
						 fxLayoutGap="5px">
						<div class="label">{{'settlementDetailView.groupLabel' | translate}}</div>
						<div>{{d?.customerBillingGroup}}</div>
					</div>
					<div *ngIf="user?.showReference" class="bottom-border-row" fxLayout="row wrap"
						 fxLayoutAlign="space-between" fxLayoutGap="5px">
						<div class="label">{{'settlementDetailView.refLabel' | translate}}</div>
						<div>{{d?.reference1}}</div>
					</div>
					<div *ngIf="user?.showOrderType && d?.orderType" class="bottom-border-row" fxLayout="row wrap"
						 fxLayoutAlign="space-between" fxLayoutGap="5px">
						<div class="label">{{'settlementDetailView.orderTypeLabel' | translate}}</div>
						<div>{{d?.orderType}}</div>
					</div>
					<div *ngIf="d?.origin?.address1" class="bottom-border-row" fxLayout="row wrap"
						 fxLayoutAlign="space-between" fxLayoutGap="5px">
						<div class="label">{{'settlementDetailView.originLabel' | translate}}</div>
						<div fxLayout="column" fxLayoutAlign="start">
							<div *ngIf="user?.showNames">{{d?.origin?.name}}</div>
							<div *ngIf="user?.showAddresses">{{d?.origin?.address1}}</div>
							<div>
								<span *ngIf="user?.showAddresses">{{d?.origin?.city}}, {{d?.origin?.state}}</span>
								<span *ngIf="user?.showZip"> {{d?.origin?.zip}} {{d?.origin?.plus4}}</span>
							</div>
						</div>
					</div>
					<div *ngIf="d?.destination?.address1" class="bottom-border-row" fxLayout="row wrap"
						 fxLayoutAlign="space-between" fxLayoutGap="5px">
						<div class="label">{{'settlementDetailView.destinationLabel' | translate}}</div>
						<div fxLayout="column" fxLayoutAlign="start">
							<div *ngIf="user?.showNames">{{d?.destination?.name}}</div>
							<div *ngIf="user?.showAddresses">{{d?.destination?.address1}}</div>
							<div>
								<span *ngIf="user?.showAddresses">{{d?.destination?.city}}, {{d?.destination?.state}}</span>
								<span *ngIf="user?.showZip"> {{d?.destination?.zip}} {{d?.destination?.plus4}}</span>
							</div>
						</div>
					</div>
					<div *ngIf="(!user?.hideItems) && d?.settlementDetailItems?.length > 0" fxLayout="column"
						 fxLayoutAlign="start" fxLayoutGap="15px">
						<h3>{{'settlementDetailView.payItemsLabel' | translate}}</h3>
						<div class="mat-table-wrapper">
							<mat-table [dataSource]="d?.settlementDetailItems">
								<ng-container matColumnDef="item">
									<mat-header-cell *matHeaderCellDef>
										{{'settlementDetailView.itemLabel' | translate}}
									</mat-header-cell>
									<mat-cell *matCellDef="let element"
											  [attr.data-label]="'settlementDetailView.itemLabel' | translate">
										{{element.description}}
									</mat-cell>
								</ng-container>
								<ng-container *ngIf="user?.showPrice" matColumnDef="price">
									<mat-header-cell *matHeaderCellDef>
										{{'settlementDetailView.priceLabel' | translate}}
									</mat-header-cell>
									<mat-cell *matCellDef="let element"
											  [attr.data-label]="'settlementDetailView.priceLabel' | translate">
										{{element.price | currency:'USD':'symbol':'1.2-2'}}
									</mat-cell>
								</ng-container>
								<ng-container *ngIf="user?.showBaseAmount" matColumnDef="base">
									<mat-header-cell *matHeaderCellDef>
										{{'settlementDetailView.baseLabel' | translate}}
									</mat-header-cell>
									<mat-cell *matCellDef="let element"
											  [attr.data-label]="'settlementDetailView.baseLabel' | translate">
										{{element.baseAmount | currency:'USD':'symbol':'1.2-2'}}
									</mat-cell>
								</ng-container>
								<ng-container *ngIf="user?.showDriverSplit" matColumnDef="driverSplit">
									<mat-header-cell *matHeaderCellDef>
										{{'settlementDetailView.driverSplitLabel' | translate}}
									</mat-header-cell>
									<mat-cell *matCellDef="let element"
											  [attr.data-label]="'settlementDetailView.driverSplitLabel' | translate">
										{{element.driverSplit}}%
									</mat-cell>
								</ng-container>
								<ng-container *ngIf="user?.showPercentOrder" matColumnDef="driverPercent">
									<mat-header-cell *matHeaderCellDef>
										{{'settlementDetailView.percentageLabel' | translate}}
									</mat-header-cell>
									<mat-cell *matCellDef="let element"
											  [attr.data-label]="'settlementDetailView.percentageLabel' | translate">
										{{element.driverPercent}}%
									</mat-cell>
								</ng-container>
								<ng-container matColumnDef="settlement">
									<mat-header-cell *matHeaderCellDef>
										{{'settlementDetailView.settlementLabel' | translate}}
									</mat-header-cell>
									<mat-cell *matCellDef="let element"
											  [attr.data-label]="'settlementDetailView.settlementLabel' | translate">
										{{element.driverCommission | currency:'USD':'symbol':'1.2-2'}}
									</mat-cell>
								</ng-container>

								<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
								<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
							</mat-table>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</ng-container>
	</div>
</div>
